import { createContext, useState, FC, useContext } from 'react';
import { Spin } from 'antd';
import LoadIcon from '@/components/LoadIcon';
import './index.less';

const LoadingContext = createContext({
  loading: false,
  setScreenLoading: (loading: boolean, tip?: string) => {},
});

const ScreenLoading: FC = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [tip, setTip] = useState('');

  const setScreenLoading = (loading: boolean, tip?: string) => {
    setLoading(loading);
    tip && setTip(tip);
    !loading && setTip('');
  };

  return (
    <LoadingContext.Provider
      value={{
        loading,
        setScreenLoading,
      }}
    >
      <Spin
        spinning={loading}
        tip={tip}
        wrapperClassName='screen-loading'
        indicator={<LoadIcon />}
      >
        {children}
      </Spin>
    </LoadingContext.Provider>
  );
};

export default ScreenLoading;

export const useScreenLoading = () => {
  const { loading, setScreenLoading } = useContext(LoadingContext);

  return {
    loading,
    setScreenLoading,
  };
};
